import React, { useState } from 'react';
import { FieldValidationError } from '../utilities/validation/validation';
import { OrderNewContainerPrefillData } from 'features/orderManagement/OrderCreateContainer';

export interface OrderCreateContextInterface {
  children?: React.ReactNode;
  validationErrors?: FieldValidationError[];
  setValidationErrors?: (errs: FieldValidationError[]) => void;
  setOrderPrefillData?: (data: OrderNewContainerPrefillData | null) => void;
  orderPrefillData?: OrderNewContainerPrefillData | null;
}
const OrderCreateContext = React.createContext<OrderCreateContextInterface | null>(null);

const OrderCreateProvider = (props: OrderCreateContextInterface): JSX.Element => {
  const [validationErrors, setValidationErrors] = useState<FieldValidationError[]>([]);
  const [orderPrefillData, setOrderPrefillData] = useState<OrderNewContainerPrefillData | null>(null);

  const ctx: OrderCreateContextInterface = {
    validationErrors,
    setValidationErrors,
    setOrderPrefillData,
    orderPrefillData,
  };

  return <OrderCreateContext.Provider value={ctx}>{props.children}</OrderCreateContext.Provider>;
};

export { OrderCreateContext, OrderCreateProvider };
